module.exports = __webpack_public_path__ + "img/blackbeards-treasure.194a808d.jpg";